import React from 'react';
import I18n from 'i18n-js';
import { Button } from 'grab-ui';
import {
  SCRIBE_SHOPIFY_STATES,
  SCRIBE_SHOPIFY_EVENTS,
} from 'applications/scribe/instrumentations/track';
import ShopifyTrackEventContext from 'views/v2/shopify-home/track-event';
import { EMPLOYEES } from 'actions/endpoint-constants';
import iconExclamation from 'public/icons/exclamation.svg';
import iconRedirectSvg from 'public/images/icon-redirect.svg';
import styles from './pax-account-content.less';
import SetupEnterpriseAccountModal from './setup-enterprise-account-modal';

const localeKeyPrefix = 'shopify.settings.manageEmployeeSection.paxAccount';

const PaxAccountContent = () => {
  const trackCtx = React.useContext(ShopifyTrackEventContext);

  const fireSetupGfbAccountTrackEvent = () => {
    trackCtx.fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_SETTINGS_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.SET_UP_GFB_ACCOUNT,
    });
  };

  const fireUnlinkPaxAccountTrackEvent = () => {
    trackCtx.fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_SETTINGS_UNLINK_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.UNLINK,
    });
  };

  const fireCancelUnlinkPaxAccountTrackEvent = () => {
    trackCtx.fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_SETTINGS_UNLINK_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.CANCEL,
    });
  };

  const [modalVisible, setModalVisible] = React.useState(false);

  const openModal = () => {
    fireSetupGfbAccountTrackEvent();
    setModalVisible(true);
  };

  const cancelUnlinkPaxAccountHandler = () => {
    fireCancelUnlinkPaxAccountTrackEvent();
    setModalVisible(false);
  };

  const confirmUnlinkPaxAccountHandler = () => {
    fireUnlinkPaxAccountTrackEvent();
    setModalVisible(false);
    const { endpoints } = window.Grab.config;
    window.open(`${endpoints.gfbAdmin}${EMPLOYEES}`);
  };

  return (
    <div className={styles.PaxAccountContentPanel}>
      <div className={styles.Notes}>
        <h3>
          <img
            className={styles.Icon}
            src={iconExclamation}
            alt={'exclamation-icon'}
          />
          {I18n.t(`${localeKeyPrefix}.notes.header`)}
        </h3>
        <p>{I18n.t(`${localeKeyPrefix}.notes.description`)}</p>
      </div>
      <div className={styles.ActionButtonsContainer}>
        <Button className={styles.ActionButton} type="link" onClick={openModal}>
          {I18n.t(`${localeKeyPrefix}.button.label`)}&nbsp;
          <img src={iconRedirectSvg} alt="redirectIcon" />
        </Button>
      </div>
      <SetupEnterpriseAccountModal
        visible={modalVisible}
        onCancel={cancelUnlinkPaxAccountHandler}
        onOk={confirmUnlinkPaxAccountHandler}
      />
    </div>
  );
};

export default PaxAccountContent;
